import { NavLink } from "react-router-dom";

const AdminNavBar = () => {
  return (
		<nav>
			<ul>
				<li>
				  <NavLink to="/timesheet">Reports</NavLink>
			  </li>
			  <li>
					<NavLink to="/userAdmin">Users</NavLink>
				</li>
				<li>
					<NavLink to="/units">Units</NavLink>
				</li>
				<li>
					<NavLink to="/timesheets">Timesheets</NavLink>
				</li>
				<li>
					<NavLink to="/locations">Locations</NavLink>
				</li>
			</ul>
		</nav>
	);
};

export default AdminNavBar;
